import type JCE from '@chesscom/js-chess-engine';
import type { SanSquare } from '@chesscom/js-chess-engine';
import type { Game } from 'chessboard/model/game/types';
import type { PieceMove } from 'chessboard/renderers/default/piece-movement/types';

/**
 * Returns the correct target square for a move node.
 * Accounts for 960 castling.
 */
export function nodeTargetSquare(node: JCE.Node.Model | Game.Move.Extended | PieceMove): SanSquare {
  return node.kingTo ?? node.to;
}
